import { RootState } from '@src/middleware/reducers/rootReducer';

export const loading = (state: RootState) => state.FaqReducer.loading || false;
export const getFaqCategoriesLoading = (state: RootState) => state.FaqReducer.categoriesLoading || false;
export const isSaving = (state: RootState) => state.FaqReducer.isSaving || false;
export const isDeleting = (state: RootState) => state.FaqReducer.isDeleting || false;
export const getFaqData = (state: RootState) => state.FaqReducer.faqData || [];
export const getFaqFormData = (state: RootState) => state.FaqReducer.faqFormData;
export const getFaqFormErrors = (state: RootState) => state.FaqReducer.faqFormErrors || {};
export const getFaqCategories = (state: RootState) => state.FaqReducer.faqCategories || [];
export const getFaqQuestionMetrics = (state: RootState) => state.FaqReducer.faqQuestionMetrics || [];
export const getFaqCategoriesError = (state: RootState) => state.FaqReducer.faqCategoriesError || '';
export const isFaqFormSaved = (state: RootState) => state.FaqReducer.isFaqFormSaved || false;
export const getFaqFormSavedError = (state: RootState) => state.FaqReducer.faqFormSavedError || '';
export const getFaqListFetchError = (state: RootState) => state.FaqReducer.faqListFetchError || '';
export const getFaqFormState = (state: RootState) => state.FaqReducer.faqFormState;
export const isFaqDeletedSuccess = (state: RootState) => state.FaqReducer.isFaqDeletedSuccess || false;
export const isFaqDeletedFailure = (state: RootState) => state.FaqReducer.isFaqDeletedFailure || false;
